import { render, staticRenderFns } from "./ThirdAppMain.vue?vue&type=template&id=28870140&scoped=true&"
import script from "./ThirdAppMain.vue?vue&type=script&lang=js&"
export * from "./ThirdAppMain.vue?vue&type=script&lang=js&"
import style0 from "./ThirdAppMain.vue?vue&type=style&index=0&id=28870140&lang=scss&scoped=true&"
import style1 from "./ThirdAppMain.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28870140",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28870140')) {
      api.createRecord('28870140', component.options)
    } else {
      api.reload('28870140', component.options)
    }
    module.hot.accept("./ThirdAppMain.vue?vue&type=template&id=28870140&scoped=true&", function () {
      api.rerender('28870140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/ThirdAppMain.vue"
export default component.exports